/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadCareAttributesInner
 */
export interface LeadCareAttributesInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    care_attribute_id: string;
    /**
     * 
     */
    category: LeadCareAttributesInnerCategoryEnum;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    created_by_user_id: string;
    /**
     * 
     */
    created_at: string;
}


/**
 * @export
 */
export const LeadCareAttributesInnerCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care',
} as const;
export type LeadCareAttributesInnerCategoryEnum = typeof LeadCareAttributesInnerCategoryEnum[keyof typeof LeadCareAttributesInnerCategoryEnum];


/**
 * Check if a given object implements the LeadCareAttributesInner interface.
 */
export function instanceOfLeadCareAttributesInner(value: object): value is LeadCareAttributesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('care_attribute_id' in value) || value['care_attribute_id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function LeadCareAttributesInnerFromJSON(json: any): LeadCareAttributesInner {
    return LeadCareAttributesInnerFromJSONTyped(json, false);
}

export function LeadCareAttributesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCareAttributesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'care_attribute_id': json['care_attribute_id'],
        'category': json['category'],
        'label': json['label'],
        'created_by_user_id': json['created_by_user_id'],
        'created_at': json['created_at'],
    };
}

export function LeadCareAttributesInnerToJSON(json: any): LeadCareAttributesInner {
    return LeadCareAttributesInnerToJSONTyped(json, false);
}

export function LeadCareAttributesInnerToJSONTyped(value?: LeadCareAttributesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'care_attribute_id': value['care_attribute_id'],
        'category': value['category'],
        'label': value['label'],
        'created_by_user_id': value['created_by_user_id'],
        'created_at': value['created_at'],
    };
}

